import { isFontAwesomeType, type FontAwesomeType } from '@canvas-builder/types/font-awesome.types'

export function applyFont(dataUrl: string | ArrayBuffer | null, fontName: string) {
  if (typeof window === 'undefined') {
    console.log('applyFont cannot be executed server-side')
    return
  }

  if (!dataUrl || typeof dataUrl !== 'string') {
    console.error('Invalid font data URL')
    return
  }

  const fontElementId = `font-${fontName}`
  if (document.getElementById(fontElementId)) return

  const newStyle = document.createElement('style')
  newStyle.id = fontElementId
  newStyle.innerHTML = `
    @font-face {
      font-family: '${fontName}';
      src: url('${dataUrl}') format('truetype'); // Assuming the font is TTF; change the format if necessary
    }
  `

  document.head.appendChild(newStyle)
}

const removeFaFromFaIcon = (faIcon: string): string => {
  return faIcon.startsWith('fa-') ? faIcon.replace('fa-', '') : faIcon
}

export function getFontAwesomeIconNameAndType(icon: string = 'far fa-question'): {
  name: string
  type?: FontAwesomeType
} {
  if (!icon) return { type: 'far', name: 'question' }

  // remove excess spaces (if any)
  const trimmedIcon = icon.trim().replace(/\s+/g, ' ')

  const [faType, faIcon] = trimmedIcon.split(' ')

  // Two cases:
  // 1. name only, e.g. 'fa-shopping-cart'
  // 2. name and type, e.g. 'fal fa-shopping-cart'
  return faType && faIcon
    ? {
        type: isFontAwesomeType(faType) ? (faType as FontAwesomeType) : undefined,
        name: removeFaFromFaIcon(faIcon),
      }
    : {
        name: isFontAwesomeType(faType) ? 'question' : removeFaFromFaIcon(faType),
      }
}
